import { NotifyForm } from '@/components/NotifyForm';
import { Reveal } from '@/components/Reveal';

export function FinalCta(): JSX.Element {
  return (
    <section className="py-16 md:py-24">
      <div className="container-content">
        <Reveal>
          <div className="relative overflow-hidden rounded-[28px] border border-nexus-purple/35 bg-gradient-to-br from-[#2a1450] to-[#120a26] p-8 text-center md:p-16">
            <div
              aria-hidden
              className="animate-drift pointer-events-none absolute -right-20 -top-20 h-[280px] w-[280px] rounded-full bg-nexus-purple/[0.25] blur-3xl"
            />
            <h2 className="relative font-display text-3xl font-bold text-nexus-ink md:text-[36px]">
              Ready to run PSA and RMM as one platform?
            </h2>
            <p className="relative mx-auto mt-3 max-w-[520px] text-white/70">
              Nexus is live in our own MSP operations and opening to a limited
              design-partner cohort. Join the private-preview list.
            </p>
            <div className="relative mt-8 flex justify-center">
              <NotifyForm />
            </div>
            <p className="relative mt-4 text-xs text-white/40">
              Building in the open — one tested module at a time. No spam, no lists sold.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
